export const OC_TOKEN = "OCToken";

let url = process.env.REACT_APP_BASE_URL_DEV;
if (process.env.REACT_APP_MODE === "prod") {
  url = process.env.REACT_APP_BASE_URL_PROD;
} else if (process.env.REACT_APP_MODE === "dev") {
  url = process.env.REACT_APP_BASE_URL_DEV;
} else {
  url = process.env.REACT_APP_BASE_URL_LOCAL;
}

export const BASE_URL = url;
